export default __webpack_public_path__ + "static/media/interessadomob.f570971c.png";